<template>
  <div>
    <h3 class="modal-title"> DIGITAL SIGNATURE </h3>

    <b-form-group :class="{'error-input' : $v.data_signature.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_signature.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeSiganture">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveSiganture">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_signature: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_signature: {
        title: '',
      },
    };
  },
  computed: {
    generateDataSignature() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_signature.title,
        component_master_id: this.dataMaster.id,
        info: '-',
        type_platform: 1,
      };
      return data;
    },

    generateDataSignatureUpdate() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_signature.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: this.dataEdit.info,
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_signature.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    saveSiganture() {
      this.$v.data_signature.$touch();
      if (!this.$v.data_signature.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataSignature,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataSignatureUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.$emit('close-field');
        this.data_signature.title = '';
        setTimeout(() => {
          this.$v.data_signature.$reset();
        }, 1000);
      }
    },

    closeSiganture() {
      this.$emit('close-field');
      this.data_signature.title = '';
      setTimeout(() => {
        this.$v.data_signature.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jDigitalSignatureSetup.vue